import AuthToken from "../auth-token.tsx";
import { MDXSection } from "./snippets";
import { StatusDiagram } from "./status-diagram";

You can run **{props.runnableName}** on Replicate using an [OpenAI-compatible API](https://platform.openai.com/docs/quickstart?context=curl).

<ol className="not-prose">
  <li>Replace `api.openai.com` with `openai-proxy.replicate.com` in your requests</li>
  <li>Set an `Authorization` header with your Replicate API token</li>
  <li>Set your `model` to <code>{ props.runnableName }</code></li>
</ol>

```console
curl -X POST https://openai-proxy.replicate.com/v1/chat/completions \
       -H "Content-Type: application/json" \
       -H "Authorization: Bearer $REPLICATE_API_TOKEN" \
       -d '{
         "model": "{{ runnableName }}",
         "messages": [
           { "role": "system", "content": "You are a helpful assistant." },
           { "role": "user", "content": "What is the capital of the moon?" }
         ]
       }'
```

You can learn about pricing for this model on the <a href={route("model_detail", { name: props.version._extras.model.name, username: props.version._extras.model.owner })}>model page</a>.
